import { useState, useEffect } from "react";
import Hero from "./Hero/Hero";
import Landing from "./Landing/Landing";

import LoadingScreen from "Components/RequestHandler/LoadingScreen";
import IsError from "Components/RequestHandler/IsError";
import useFetch from "Hooks/useFetch.js";
const ISO = () => {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { fetchData, error } = useFetch();

  const getData = async () => {
    setIsLoading(true);
    setIsError(false);

    try {
      const data = await fetchData("iso");
      setData(data);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <main>
      <Hero data={data} />
      <Landing data={data} />
    </main>
  );
};

export default ISO;
